<template>
    <v-menu v-model="date_sync" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y
        min-width="290px">
        <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="date" :label="label" prepend-icon="mdi-calendar" v-bind="attrs" v-on="on" @input="handleInput"/>
        </template>
        <v-date-picker v-model="date" first-day-of-week="1" @input="handleInputPicker" />
    </v-menu>

</template>

<script>
export default {
    name: "DatePickerProgramy",
    props: {
        label: { required: true, type: String },
        value: { required: true, type: String }
    },

    data() {
        return {
            date_sync: false,
            date: this.value
        };
    },
    methods: {
        handleInput(e) {
            this.$emit('input', this.date)
        },

        handleInputPicker(e) {
            this.date_sync = false;
            this.handleInput(e);
        }
    }
}
</script>